export const UPLOAD_URL = `${process.env.VUE_APP_BASE_API}/common/uplaod/image`;
export const UPLOAD_URL_WATER = `${process.env.VUE_APP_BASE_API}/common/uplaod/imageWater`;
export const UPLOAD_FILE_URL = `${process.env.VUE_APP_BASE_API}/common/uplaod/file`;
export const EDITOR_UPLOAD_IMAGE = `${process.env.VUE_APP_BASE_API}/common/uplaod/editorUploadImage`;

